export const LineItemTypeOptions = {
    PRODUCT: 'product',
    TAX: 'tax',
    FEE: 'fee',
};
export const TAX_CODE_OTHER_EXEMPT = {
    label: 'No',
    value: '99999',
};
export const TAX_CODE_FULLY_TAXABLE = {
    label: 'Yes',
    value: '',
};
export const DEFAULT_INPUT_DATE_FORMAT = 'yyyy-MM-dd';
export const ON_HST_TAX_RATE = 13;
export var LineItemFocusType;
(function (LineItemFocusType) {
    LineItemFocusType["Required"] = "required";
    LineItemFocusType["LowConfidence"] = "low-confidence";
})(LineItemFocusType || (LineItemFocusType = {}));
//# sourceMappingURL=OcrTypes.js.map